import { motion } from "framer-motion";
import { Eyebrow, EASE } from "@/components/Reveal";

const STATEMENTS = [
  { n: "I", line: "Une seule demande.", sub: "Vous décrivez. Nous activons un réseau de fournisseurs sur plusieurs marchés." },
  { n: "II", line: "Un réseau, pas un catalogue.", sub: "Références rares, épuisées ou introuvables en boutique : nous les recherchons pour vous." },
  { n: "III", line: "La discrétion comme règle.", sub: "Un interlocuteur unique, des échanges privés, une acquisition accompagnée jusqu'à la remise." },
];

const Statement = ({ s, i }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-15%" }}
    transition={{ duration: 1.3, ease: EASE, delay: 0.1 }}
    className={`py-20 lg:py-28 border-t border-white/[0.06] grid lg:grid-cols-12 gap-6 lg:gap-10 items-baseline ${i === STATEMENTS.length - 1 ? "border-b" : ""}`}
    data-testid={`manifesto-${i}`}
  >
    <span className="lg:col-span-2 font-display text-gold/70 text-2xl">{s.n}</span>
    <h3 className="lg:col-span-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-ivory">{s.line}</h3>
    <p className="lg:col-span-4 text-sm sm:text-base text-stone2 leading-relaxed lg:pt-3">{s.sub}</p>
  </motion.div>
);

export default function Manifesto() {
  return (
    <section id="pourquoi" className="relative py-32 lg:py-48" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Eyebrow className="mb-16 lg:mb-24 !tracking-[0.55em]">La Maison Babylon</Eyebrow>
        {STATEMENTS.map((s, i) => (
          <Statement key={s.n} s={s} i={i} />
        ))}
      </div>
    </section>
  );
}
